import { useSyncExternalStore } from 'react';

/*
 * `clientWidth`, not `innerWidth`: the latter counts the scrollbar, and a
 * layout sized to space it does not have gives itself a second scrollbar.
 */
function viewportWidth(): number {
  return document.documentElement.clientWidth;
}

function subscribeToWidth(onChange: () => void): () => void {
  window.addEventListener('resize', onChange);

  return () => window.removeEventListener('resize', onChange);
}

/**
 * How wide the page is, in pixels, kept up to date as the window is resized.
 *
 * For layouts whose threshold is not a fixed number and therefore cannot be a
 * media query: the chat drawer is dragged to any width and shrinks to fit, so
 * where it stands is arithmetic on the room available rather than a breakpoint.
 */
export function useViewportWidth(): number {
  return useSyncExternalStore(
    subscribeToWidth,
    viewportWidth,
    /* Rendered without a window, nothing fits beside anything. */
    () => 0,
  );
}
